class ThemeEvents {
  static cartUpdate = 'cart-update';
  static quantityUpdate = 'quantity-update';
  static optionValueSelectionChange = 'option-value-selection-change';
  static variantChange = 'variant-change';
  static cartError = 'cart-error';
}

class CartUpdateEvent extends CustomEvent {
  constructor(detail) {
    super(ThemeEvents.cartUpdate, { bubbles: true, detail });
  }
}

class CartErrorEvent extends CustomEvent {
  constructor(detail) {
    super(ThemeEvents.cartError, { bubbles: true, detail });
  }
}

class VariantChangeEvent extends CustomEvent {
  constructor(detail) {
    super(ThemeEvents.variantChange, { bubbles: true, detail });
  }
}

class QuantityUpdateEvent extends CustomEvent {
  constructor(detail) {
    super(ThemeEvents.quantityUpdate, { bubbles: true, detail });
  }
}

class OptionValueSelectionChangeEvent extends CustomEvent {
  constructor(detail) {
    super(ThemeEvents.optionValueSelectionChange, { bubbles: true, detail });
  }
}

const THEME_EVENT_CLASS_MAP = {
  [ThemeEvents.cartUpdate]: CartUpdateEvent,
  [ThemeEvents.cartError]: CartErrorEvent,
  [ThemeEvents.variantChange]: VariantChangeEvent,
  [ThemeEvents.quantityUpdate]: QuantityUpdateEvent,
  [ThemeEvents.optionValueSelectionChange]: OptionValueSelectionChangeEvent,
};

function createThemeEvent(eventName, data) {
  const EventClass = THEME_EVENT_CLASS_MAP[eventName];
  return EventClass ? new EventClass(data) : new CustomEvent(eventName, { bubbles: true, detail: data });
}
